
import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  console.error('Missing Supabase environment variables');
  throw new Error('Missing Supabase environment variables');
}

// Remove any trailing colons from the URL
const cleanSupabaseUrl = supabaseUrl.replace(/:\/*$/, '');

console.log('Initializing Supabase client with:', {
  url: cleanSupabaseUrl,
  hasAnonKey: !!supabaseAnonKey
});

export const supabase = createClient(cleanSupabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: false,
    storage: localStorage,
    storageKey: 'supabase.auth.token',
  }
});

// Add a listener for auth events
supabase.auth.onAuthStateChange((event, session) => {
  console.log('Auth state changed:', event, 'Session:', !!session);
  
  if (event === 'SIGNED_OUT' || !session) {
    console.log('Clearing auth data...');
    // Clear all auth related data
    localStorage.removeItem('supabase.auth.token');
    sessionStorage.removeItem('supabase.auth.token');
  } else if (event === 'SIGNED_IN' || event === 'TOKEN_REFRESHED') {
    console.log('Session updated:', event);
  }
});
